import { Link } from 'react-router-dom';
import { reopenCookieBanner } from './CookieConsentBanner';
import { SITE_URL } from '../screens/legal/shared';

// Mirrors landing/templates.mjs footer(): brand column + Product / Company /
// Legal columns (4 -> 2 -> 1) and a bottom row with the copyright. Legal
// links stay on the app's own routes (all exist - see App.tsx); the
// marketing pages live on zmist.co. Renders in-flow, not fixed (see
// App.tsx's SiteWideFooter, which skips /public/* routes).
const COL_TITLE = 'text-[12px] font-semibold uppercase tracking-wider text-(--color-text)/55 m-0 mb-3';
const LINK = 'text-[14px] text-(--color-text)/75 hover:text-(--color-accent) no-underline';

export function PublicSiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="w-full border-t border-(--color-divider) bg-(--color-bg) text-(--color-text) shrink-0">
      <div className="max-w-[1200px] mx-auto px-[clamp(20px,5vw,72px)] py-10 grid gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <a href={SITE_URL} className="inline-flex items-center gap-2 no-underline text-inherit">
            <img src="/zmist-logo.svg" alt="" className="w-7 h-7" />
            <span className="text-[18px] font-extrabold tracking-tight">Zmist</span>
          </a>
          <p className="text-[14px] text-(--color-text)/65 mt-3 mb-0">Publish what changes. Follow what matters.</p>
        </div>
        <nav aria-label="Product">
          <h2 className={COL_TITLE}>Product</h2>
          <ul className="list-none p-0 m-0 flex flex-col gap-2">
            <li><Link to="/public" className={LINK}>Explore</Link></li>
            <li><a href={`${SITE_URL}/how-it-works/`} className={LINK}>How it works</a></li>
            <li><a href={`${SITE_URL}/pricing/`} className={LINK}>Pricing</a></li>
            <li><Link to="/register" className={LINK}>Create a channel</Link></li>
          </ul>
        </nav>
        <nav aria-label="Company">
          <h2 className={COL_TITLE}>Company</h2>
          <ul className="list-none p-0 m-0 flex flex-col gap-2">
            <li><a href={`${SITE_URL}/about/`} className={LINK}>About</a></li>
            <li><a href="mailto:support@zmist.co" className={LINK}>Support</a></li>
            <li><a href="https://kuetix.com" className={LINK}>kuetix.com</a></li>
            <li><Link to="/status" className={LINK}>Status</Link></li>
          </ul>
        </nav>
        <nav aria-label="Legal">
          <h2 className={COL_TITLE}>Legal</h2>
          <ul className="list-none p-0 m-0 flex flex-col gap-2">
            <li><Link to="/terms" className={LINK}>Terms</Link></li>
            <li><Link to="/privacy" className={LINK}>Privacy</Link></li>
            <li><Link to="/cookies" className={LINK}>Cookies</Link></li>
            <li><Link to="/subprocessors" className={LINK}>Sub-processors</Link></li>
            <li><Link to="/dpa" className={LINK}>DPA</Link></li>
            <li>
              <button type="button" onClick={() => reopenCookieBanner()} className={`${LINK} bg-transparent border-0 p-0 cursor-pointer`}>
                Cookie settings
              </button>
            </li>
          </ul>
        </nav>
      </div>
      <div className="border-t border-(--color-divider)">
        <div className="max-w-[1200px] mx-auto px-[clamp(20px,5vw,72px)] py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-[13px] text-(--color-text)/60">
          <p className="m-0">© {year} Zmist</p>
          <p className="m-0">
            Built with <a href="https://kuetix.com" className="hover:text-(--color-accent)">kuetix</a> and AI
          </p>
        </div>
      </div>
    </footer>
  );
}
